/*
 * Copyright (C) 2022 Pitagon., JSC. - All Rights Reserved.
 *
 * Unauthorized copying or redistribution of this file in source and binary forms via any medium
 * is strictly prohibited.
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatRippleModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {RouterModule} from '@angular/router';
import {NavigationItemModule} from '@pitagon/ngx-pids/components';
import {NavigationComponent} from './navigation.component';

@NgModule({
  declarations: [NavigationComponent],
  imports: [
    CommonModule,
    MatRippleModule,
    MatMenuModule,
    MatIconModule,
    RouterModule,
    NavigationItemModule
  ],
  exports: [NavigationComponent]
})
export class NavigationModule {
}
